export default "/images/7952b0a152fc53aed39cb0f0201f238e.png";